<template>
    <div>
        
    </div>
</template>

<script>
export default {
    name: 'WebsiteVueIndex',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>